<script setup>
import { computed, inject, ref, watch } from 'vue'
import * as Auth from '@/services/Auth'
import { RouterLink } from 'vue-router'
import { useRoute } from 'vue-router'
import MenuMobile from './MenuMobile.vue'
import { goToTournament, seasonName } from '@/services/utils'

const tournament = inject('tournament')
const editMode = inject('editMode')
const allSeasons = inject('allSeasons')
const currents = inject('currents')

const route = useRoute()
const canEdit = computed(() => {
  return Auth.isTournamentOwned(tournament.value)
})

const selectedSeason = ref(currents.value.season.season_number)

watch(selectedSeason, (newSeasonNumber) => {
  goToTournament(tournament.value.slug, { s: newSeasonNumber })
})
</script>


<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center my-2">
          <RouterLink :to="{ name: 'tournament-show' }"
            class="d-flex align-center cursor-pointer text-decoration-none text-white">
            <v-icon size="40" class="mr-4" color="primary">mdi-trophy</v-icon>
            <h2>{{ tournament.name }}</h2>
          </RouterLink>

          <v-spacer></v-spacer>
          
          <!-- Actions menu -->
          <div v-if="canEdit" class="d-flex align-center ga-2">

            <div v-if="allSeasons.length > 1"
              class="text-medium-emphasis"
            >
              <v-select v-model="selectedSeason"
                :items="allSeasons"
                :item-title="seasonName"
                item-value="season_number"
                hide-details
                variant="plain"
                density="compact"
               />
            </div>

            <template v-if="route.name == 'tournament-show' || route.name == 'tournament-round'">
              <v-btn
                variant="text"
                :color="editMode ? 'amber' : 'primary'"
                :prepend-icon="editMode ? 'mdi-alert' : 'mdi-pencil'"
                class="d-none d-sm-flex"
                @click="editMode = !editMode"
              >
                {{ editMode ? $t('common.editing') : $t('common.edit') }}
              </v-btn>
            </template>
            
            <!-- <v-btn v-if="editMode"
              :to="{ name: 'tournament-entries' }"
              variant="text"
              color="primary"
              prepend-icon="mdi-account-group"
              class="d-none d-sm-flex"
            >
              {{ $t('label.manage_entries') }}
            </v-btn>

            <v-btn v-if="editMode"
              :to="{ name: 'tournament-settings' }"
              variant="text"
              color="primary"
              prepend-icon="mdi-cog"
              class="d-none d-sm-flex"
            >
              {{ $t('navigation.settings') }}
            </v-btn> -->
          
            
            <!-- Mobile menu -->
            <div class="d-md-none">
              <MenuMobile />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
